/* eslint-disable react/jsx-no-bind */
// @flow
import * as React from 'react';

import DraggableBox from './DraggableBox';

import useLatest from 'common/hooks/useLatest';

import {
    PermissionMatch,
    RoleOperationEnum,
    AccessDeniedToast
} from 'common/modules/rbac';

type Props = $Diff<
    React.ElementProps<typeof DraggableBox>,
    { keyCombination: string, draggableCancel: any }
>;

const MissingPermissionToast = ({ callback }: { callback: () => void }) => {
    const callbackRef = useLatest(callback);

    React.useEffect(() => {
        callbackRef.current();
    }, [callbackRef]);

    return <AccessDeniedToast action="xyzzy" />;
};

const XyzzyDialog = (props: Props): React.Node => {
    return (
        <DraggableBox
            {...props}
            keyCombination="x y z z y"
            draggableCancel=".draggableCancel"
            render={dialog => (
                <PermissionMatch
                    operations={RoleOperationEnum.ENABLE_XYZZY}
                    render={hasPermission => {
                        return hasPermission ? (
                            props.render(dialog)
                        ) : (
                            <MissingPermissionToast
                                callback={() => dialog.hide()}
                            />
                        );
                    }}
                />
            )}
        />
    );
};

export default XyzzyDialog;
